/*
 * @Description: 活动方案
 * @Author: ywl
 * @Date: 2021-03-31 10:44:33
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-12-04 10:15:20
 */
import { RouteConfig } from 'vue-router';
import PView from '../layouts/view.vue';

const programmeRoute: RouteConfig[] = [
  {
    path: '/programme',
    component: PView,
    redirect: '/programme/index.html',
    children: [
      {
        path: 'index.html',
        name: 'programmeIndex',
        component: () => import('@/views/programme/index.vue'),
        meta: { title: '', parentTab: 'programme' },
      },
      {
        path: 'detail.html',
        name: 'programmeDetail',
        component: () => import('@/views/programme/detail.vue'),
        meta: { title: '活动方案详情', parentTab: 'programme' },
      },
    ],
  },
];

export { programmeRoute };
